import {UIGameManager} from '../UIGameManager'
import {BaseCardData, SelectCardPopupForPendingDistributionFormat} from '@colonist/game-card-types'
import {PopupInformation} from '@colonist/game-base-types'
import {CardDistributionType, TileCornerBuildingType, TileEdgeType} from '@colonist/game-states'
import {robberSkinController} from '../UIGameRobberSkinController'
import {CARD_IMAGES, CARD_POPUP_BODY, CARD_TIP_TITLE} from '@colonist/ui-game'
import {UIImagePathController} from '../../UIEnums.ts'
import TileGold from '@static/images/tile_gold.svg'
import IconAqueduct from '@static/images/icon_aqueduct.svg'
import IconBarbarianShip from '@static/images/icon_barbarian_ship.svg'

export class UIGamePopupInformationView {
    static getPopupInformationForCardData(cardData: BaseCardData): PopupInformation {
        const newPopupInformation: PopupInformation = {
            imagePath: CARD_IMAGES[cardData.cardEnum],
            title: CARD_TIP_TITLE[cardData.cardEnum],
            body: CARD_POPUP_BODY[cardData.cardEnum],
        }
        return newPopupInformation
    }

    static getPopupInformationForPendingDistributions(pendingDistributionSelectFormat: SelectCardPopupForPendingDistributionFormat): PopupInformation | undefined {
        switch(pendingDistributionSelectFormat.selectionType) {
            case CardDistributionType.ResourceTile:
            case CardDistributionType.StartingResources: return undefined
            case CardDistributionType.GoldTile: return UIGamePopupInformationView.getPopupInformationForGoldTileDistribution(pendingDistributionSelectFormat)
            case CardDistributionType.Aqueduct: return UIGamePopupInformationView.getPopupInformationForAqueductDistribution(pendingDistributionSelectFormat)
            case CardDistributionType.BarbarianProgressCard: return UIGamePopupInformationView.getPopupInformationForBarbarianProgressCardDistribution(pendingDistributionSelectFormat)
        }
    }

    static getPopupInformationForGoldTileDistribution(pendingDistributionSelectFormat: SelectCardPopupForPendingDistributionFormat): PopupInformation {
        const amountToSelect = pendingDistributionSelectFormat.selectCardFormat.amountOfCardsToSelect

        const popupInformation: PopupInformation = {
            imagePath: TileGold,
            title: {key: 'strings:game.distribution.goldTile'},
            body: {
                key: 'strings:game.distribution.body',
                options: {
                    count: amountToSelect,
                },
            },
        }
        return popupInformation
    }

    static getPopupInformationForAqueductDistribution(pendingDistributionSelectFormat: SelectCardPopupForPendingDistributionFormat): PopupInformation {
        const amountToSelect = pendingDistributionSelectFormat.selectCardFormat.amountOfCardsToSelect

        const popupInformation: PopupInformation = {
            imagePath: IconAqueduct,
            title: {key: 'strings:game.distribution.aqueduct'},
            body: {
                key: 'strings:game.distribution.body',
                options: {
                    count: amountToSelect,
                },
            },
        }
        return popupInformation
    }

    static getPopupInformationForBarbarianProgressCardDistribution(pendingDistributionSelectFormat: SelectCardPopupForPendingDistributionFormat): PopupInformation {
        const popupInformation: PopupInformation = {
            imagePath: IconBarbarianShip,
            title: {key: 'strings:game.distribution.barbarianProgressCard.title'},
            body: {key: 'strings:game.distribution.barbarianProgressCard.body'},
        }
        return popupInformation
    }

    static getPopupInformationForPlayerRolledSeven(uiGameManager: UIGameManager): PopupInformation {
        const popupInformation: PopupInformation = {
            imagePath: robberSkinController.getRobberSkin(),
            title: {key: 'strings:game.tips.robber.title'},
            body: {key: 'strings:game.prompts.playerRolledSeven'},
        }
        return popupInformation
    }

    static getPopupInformationForInitialRoadPlacement(uiGameManager: UIGameManager): PopupInformation {
        const imagePath = UIImagePathController.roadsByColor[uiGameManager.gameController.myColor]

        const isFirstInitialRoad = uiGameManager.gameController.mapValidator.tileState.getPlacedEdgePieceCountForPlayer(TileEdgeType.Road, uiGameManager.gameController.myColor) == 0

        if(isFirstInitialRoad) {
            return {
                imagePath: imagePath,
                title: {key: 'strings:game.prompts.initialPlacements.firstRoad.title'},
                body: {key: 'strings:game.prompts.initialPlacements.firstRoad.body'},
            }
        }

        return {
            imagePath: imagePath,
            title: {key: 'strings:game.prompts.initialPlacements.secondRoad.title'},
            body: {key: 'strings:game.prompts.initialPlacements.secondRoad.body'},
        }
    }

    static getPopupInformationForInitialSettlementPlacement(uiGameManager: UIGameManager): PopupInformation {
        const imagePath = UIImagePathController.settlementsByColor[uiGameManager.gameController.myColor]

        const placedSettlementAmount = uiGameManager.gameController.mapValidator.tileState.getPlacedCornerBuildingCountForPlayer(TileCornerBuildingType.Settlement, uiGameManager.gameController.myColor)
        const isFirstInitialSettlement = placedSettlementAmount == 0

        if(isFirstInitialSettlement) {
            return {
                imagePath: imagePath,
                title: {key: 'strings:game.prompts.initialPlacements.firstSettlement.title'},
                body: {key: 'strings:game.prompts.initialPlacements.firstSettlement.body'},
            }
        }

        return {
            imagePath: imagePath,
            title: {key: 'strings:game.prompts.initialPlacements.secondSettlement.title'},
            body: {key: 'strings:game.prompts.initialPlacements.secondSettlement.body'},
        }
    }
}
